import React from 'react';
import classNames from '../utility/classNames';
import lightLogo from '../assets/logo/logo-light.svg';
import darkLogo from '../assets/logo/logo-dark.svg';

function Logo({ variant = 'light', size = 'small', className = '' }) {
  return (
    <img
      src={variant === 'light' ? lightLogo : darkLogo}
      alt="Company Logo"
      className={classNames(
        size === 'small' && 'h-6',
        size === 'md' && 'h-12',
        size === 'large' && 'h-20',
        size === 'xl' && 'h-24',
        size === '2xl' && 'h-32',
        className
      )}
    ></img>
  );
}

export default Logo;
